module.exports = __webpack_public_path__ + "static/media/missing-avatar.d77f2493.png";